import { useState } from 'react';

export const useInlineEdit = () => {
    const [editingId, setEditingId] = useState(null);
    const [editValue, setEditValue] = useState('');

    const start = (id, currentValue) => {
        setEditingId(id);
        setEditValue(currentValue);
    };

    const cancel = () => {
        setEditingId(null);
        setEditValue('');
    };

    return { editingId, editValue, setEditValue, start, cancel };
};
